import React, { useEffect, useRef, useState } from "react";
import useCountUp from "../../../hooks/useCountUp";
import { StatsCardProps } from "../../../models";

const StatsCard: React.FC<StatsCardProps> = ({ icon, title, value }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLLIElement>(null);
  const count = useCountUp(2000, isVisible ? Number(value) : 0);
  const isPercentage = title === "Mức độ hài lòng";

  useEffect(() => {
    const ref = cardRef.current;
    if (!ref) return;

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(ref);
    return () => observer.disconnect();
  }, []);

  return (
    <li ref={cardRef} className="flex w-full justify-center">
      <div className="group w-full max-w-[320px] rounded-2xl border border-red-100 bg-white/95 shadow-[0_18px_45px_rgba(127,29,29,0.08)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-red-200 hover:shadow-[0_24px_60px_rgba(185,28,28,0.14)]">
        <div className="px-4 py-4 sm:px-5 sm:py-5">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl border border-red-100 bg-gradient-to-br from-red-50 via-white to-red-100 shadow-[0_10px_24px_rgba(220,38,38,0.12)] transition-transform duration-300 group-hover:scale-105 sm:h-12 sm:w-12">
              <div className="text-red-600">{icon}</div>
            </div>

            <div className="min-w-0 flex-1">
              <p className="text-[1.65rem] font-semibold leading-none tracking-tight text-red-600 sm:text-[1.85rem] lg:text-[2.05rem]">
                {isPercentage ? count : `+${count}`}
                {isPercentage ? "%" : ""}
              </p>
              <p className="mt-1.5 text-[13px] font-medium leading-5 text-slate-700 sm:mt-2 sm:text-[14px] md:text-[15px]">
                {title}
              </p>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

export default StatsCard;
